/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitFixedPrice } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const usePatchBenefitFixedPrice = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((data: IBenefitFixedPrice) => BenefitsService.patchBenefitFixedPrice(data), {
    onSuccess: () => {
      AlertAdapter('Fixed price edited successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['benefits/prices'] });
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
  return mutation;
};
